import { render, staticRenderFns } from "./DialogAddTaskManagement.vue?vue&type=template&id=4f739a4c&scoped=true"
import script from "./DialogAddTaskManagement.vue?vue&type=script&lang=js"
export * from "./DialogAddTaskManagement.vue?vue&type=script&lang=js"
import style0 from "./DialogAddTaskManagement.vue?vue&type=style&index=0&id=4f739a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f739a4c",
  null
  
)

export default component.exports